import { useState } from 'react';
import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import VideoPlayer from '../../Video/VideoPlayer';
import RichText from '../../../Core/RichText';

import {
  StyledContainer,
  VideoWrapper,
  VideoDescription,
  Title,
  TranscriptWrapper,
  TranscriptButton,
  BottomContent,
  Transcript,
  Ulist,
  Olist,
} from './styles';

const transcriptFormat = {
  renderNode: {
    [BLOCKS.OL_LIST]: (_, children) => <Olist>{children}</Olist>,
    [BLOCKS.UL_LIST]: (_, children) => <Ulist>{children}</Ulist>,
  },
};

const FAQVideo = ({ data = null }) => {
  if (!data) return null;

  const {
    videoId,
    videoLabel,
    videoDescription,
    transcript,
    showTranscriptLabel,
    hideTranscriptLabel,
  } = data;

  const [toggle, setToggle] = useState(false);

  return (
    <StyledContainer className="FAQVideo" id="faq-video">
      <Title>
        <h2>{videoLabel}</h2>
      </Title>
      <VideoWrapper>
        <VideoPlayer
          type="youtube"
          url={`https://www.youtube.com/watch?v=${videoId}`}
          playing={false}
        />
        {videoDescription && (
          <VideoDescription>
            <RichText document={videoDescription} />
          </VideoDescription>
        )}
      </VideoWrapper>
      {transcript && (
        <BottomContent>
          <TranscriptWrapper>
            {toggle && (
              <Transcript>
                <RichText document={transcript} options={transcriptFormat} />
              </Transcript>
            )}
            {toggle ? (
              <TranscriptButton
                className="hide"
                onClick={() => setToggle(!toggle)}
              >
                <span>{hideTranscriptLabel}</span>
              </TranscriptButton>
            ) : (
              <TranscriptButton onClick={() => setToggle(!toggle)}>
                <span>{showTranscriptLabel}</span>
              </TranscriptButton>
            )}
          </TranscriptWrapper>
        </BottomContent>
      )}
    </StyledContainer>
  );
};

FAQVideo.propTypes = {
  data: PropTypes.shape(),
};

export default FAQVideo;
